module.exports = "<!--\n  This file contains:\n  1. Menubar\n-->\n\n<!-- Menubar starts -->\n<app-nav></app-nav>"